module.exports = __webpack_public_path__ + "img/SepticTank.f2970842.svg";